import React, { Component } from 'react';

class Loader extends Component {
	render() {
		let url = process.env.PUBLIC_URL + '/img/loader.svg'
		return <img src={url} width="30" alt="Loading" />
	}
}

export default Loader;